import Button from '../common/Button';
import lighting from '../../../assets/svg/lighten-white.svg'
import appleStore from '../../../assets/svg/apple-store.svg'
import playStore from '../../../assets/svg/play-store.svg'
import circleArrowUp from '../../../assets/svg/circle-arrow-up.svg'
import pattern4 from '../../../assets/svg/pattern4.svg'

function Footer(props) {

    const merchant = JSON.parse( window.localStorage.getItem("bMerchant") || "[]") || []

    const scrollToTop = duration => {
        // cancel if already on top
        if (document.scrollingElement.scrollTop === 0) return;
    
        const totalScrollDistance = document.scrollingElement.scrollTop;
        let scrollY = totalScrollDistance, oldTimestamp = null;
    
        function step (newTimestamp) {
            if (oldTimestamp !== null) {
                // if duration is 0 scrollY will be -Infinity
                scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;
                if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;
                document.scrollingElement.scrollTop = scrollY;
            }
            oldTimestamp = newTimestamp;
            window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
    }

    return (
        <div className="Footer relative bg-yellow flex justify-center flex-col px-8 lg:px-16 py-6 items-center" id="footer">

            <div className="absolute top-0 left-0 right-0">
                <img src={pattern4} alt="pa" />
            </div>

            <div className="text-4xl lg:text-5xl text-center text-brown-dark mt-20 leading-none" >
                The only thing dear to our heart is to bring you <br/> 
                closer and faster to your money.
            </div>
            <div className="flex flex-col items-center lg:mt-8 mb-12">
                <Button onClick={ props.onButtonClick } className="text-white border-0 bg-brown-dark flex items-center m-4 text-xs px-5 py-3 rounded-md font-bold">
                    <img src={lighting} alt="z" width="7px"/> &nbsp; Sell your BTC @ ₦{ merchant.buying_at || "425"}
                </Button>
                <div className="flex">
                    <img src={appleStore} alt="a" />
                    <img src={playStore} alt="g" />
                </div>
            </div>

            <div className="mt-8 relative w-full ">
                <div className="absolute right-0 bottom-img-pattern" >
                    <img src={pattern4} alt="pa"  />
                </div>
            </div>
            
            <div className="mt-12 flex justify-between px-0 flex-col lg:flex-row lg:px-16 py-6 items-between w-full text-brown text-xs">
                <div className="text-center lg:text-left">
                    Copyright © 2020 Bitcoinaboki. All rights reserved.
                </div>
                <div className="text-center lg:text-left">
                    <a href="/privacy">Privacy Policy</a>
                </div>
                <div className="text-center lg:text-left">
                30a Alternative Route, off Chevron Drive,Lekki, Lagos Nigeria
                </div>
                <div className="text-center lg:text-left">
                (234) 902-352 9871
                </div>
                <div className="flex items-center cursor-pointer justify-center lg:justify-left" onClick={() => scrollToTop(1000)}>
                    Back to top &nbsp; <img src={circleArrowUp} alt="`"/>
                </div>
            </div>
        </div>
    );
  }
  
  export default Footer;
  